var EHDI = EHDI || Object.create(null);

EHDI.manager = EHDI.manager || Object.create(null);

EHDI.manager.DataManager = function() {
    
    var _this = this;
    var _data;
    
    var initData = function(){
        _data = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.dataID) || null;
        
        var commonData = EHDI.Assets.fetch( "rarity_0" );
        var uncommonData = EHDI.Assets.fetch( "rarity_1" );
        var rareData = EHDI.Assets.fetch( "rarity_2" );
        
        if( _data === null ){
            _data = { fish: [], powerups: [], junk: [], lang: EHDI.GAME.localeID };
            
            var fishCount = commonData.fish.length + uncommonData.fish.length + rareData.fish.length;
            var powerCount = commonData.powerup.length + uncommonData.powerup.length + rareData.powerup.length;
            var junkCount = commonData.junk.length + uncommonData.junk.length + rareData.junk.length;
            
            for( var i = 0; i < fishCount; i++ ){
                var fishData = { name: "??????", id: i, weight: 0, caught: false };
                _data.fish.push( fishData );
            }

            for( var i = 0; i < powerCount; i++ ){
                var powerupData = { id: i, stock: 0 };
                _data.powerups.push( powerupData );
            }

            for( var i = 0; i < junkCount; i++ ){
                var junkData = { name: "??????", id: i, weight: 0, caught: false };
                _data.junk.push( junkData );
            }
        }
        else{
            if( _data.lang === EHDI.GAME.localeID ) return;
            
            for( var i = 0; i < _data.fish.length; i++ ){
                if( _data.fish[i].name.charAt(0) === "?" ) continue;
                _data.fish[i].name = EHDI.localization.strings[ "fish_" + i ].content;
            }
            
            for( var i = 0; i < _data.junk.length; i++ ){
                if( _data.junk[i].name.charAt(0) === "?" ) continue;
                _data.junk[i].name = EHDI.localization.strings[ "junk_" + i ].content;
            }
        }
    }
    
    this.getData = function(){ return _data; }

    this.addCaughtFish = function( fishData ){
        var curFish = _data.fish[ fishData.id ];
        
        var origWeight = curFish.weight * 1;
        var caughtWeight = fishData.newWeight * 1;
        
        if( curFish.name[0] === "?" )   curFish.name = EHDI.localization.strings["fish_" + fishData.id].content;
        if( origWeight < caughtWeight ) curFish.weight = fishData.newWeight;
        if( !curFish.caught )           curFish.caught = true;
        
        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.dataID, _data);
    }

    this.addCaughtPowerup = function( powerupData ){
        var curPowerup = _data.powerups[ powerupData.id ];
        curPowerup.stock = curPowerup.stock + 1;

        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.dataID, _data);
    }
    
    this.usePowerup = function( index ){
        var curPowerup = _data.powerups[ index ];
        curPowerup.stock = curPowerup.stock - 1;
        if( curPowerup.stock < 0 ) curPowerup.stock = 0;

        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.dataID, _data);
    }

    this.addCaughtJunk = function( junkData ){
        var curJunk = _data.junk[ junkData.id ];
        
        var origWeight = curJunk.weight * 1;
        var caughtWeight = junkData.newWeight * 1;
        
        if( curJunk.name[0] === "?" )   curJunk.name = EHDI.localization.strings["junk_" + junkData.id].content;
        if( origWeight < caughtWeight ) curJunk.weight = junkData.newWeight;
        if( !curJunk.caught )           curJunk.caught = true;

        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.dataID, _data);
    }
    
    initData();
}

EHDI.manager.DataManager.prototype = Object.create(null);